module.exports = __webpack_public_path__ + "img/img20.f059b0f8.png";